import { apiPost } from '@/utils/api';
import getPath from '@/utils/getPath';
import { handleApiError } from '@/utils/errorHandler';

export const searchApi = {
  /**
   * Searches work items by query term.
   * @apiRoute POST '/search/workItems'
   */
  async searchWorkItems(payload) {
    try {
      const response = await apiPost(getPath('search/workItems'), payload);
      return response.data;
    } catch (err) {
      await handleApiError(err, 'searchWorkItems');
    }
  },

  /**
   * Searches work item notes by query term.
   * @apiRoute POST '/search/workItems/notes'
   */
  async searchWorkItemNotes(payload) {
    try {
      const response = await apiPost(
        getPath('search/workItems/notes'),
        payload
      );
      return response.data;
    } catch (err) {
      await handleApiError(err, 'searchWorkItemNotes');
    }
  },
};
